import React from 'react';
import { Outlet } from 'react-router-dom';
import { useStore } from '../context/StoreContext';
import { useAuth } from '../context/AuthContext';
import HandheldNav from './components/HandheldNav';

const HandheldLayout = () => {
  const { activeStore } = useStore();
  const { user } = useAuth();

  return (
    <div className="min-h-screen flex flex-col bg-slate-950 text-white">
      <header className="px-4 py-3 border-b border-slate-800">
        <div className="flex flex-col">
          <span className="text-xs uppercase tracking-[0.4em] text-slate-400">Handheld Mode</span>
          <div className="flex items-baseline justify-between">
            <h1 className="text-xl font-semibold">
              {activeStore?.name || 'No store selected'}
            </h1>
            <span className="text-sm text-slate-300">{user?.name}</span>
          </div>
          {activeStore?.address?.suburb && (
            <span className="text-xs text-slate-500">{activeStore.address.suburb}</span>
          )}
        </div>
      </header>

      <main className="flex-1 overflow-y-auto bg-slate-100 text-slate-900">
        <Outlet />
      </main>

      <HandheldNav />
    </div>
  );
};

export default HandheldLayout;
